export var DATA_TEST_AND_ARIA_REGEXP = /^(data-test|aria)-/;
export var DATA_TEST_REGEXP = /^data-test-/;
export var DATA_REGEXP = /^data-/;